import type { PhoneVerificationState, PhoneVerificationStatus } from "../lib/todo26-contract.ts"
import { Icon } from "./icons.tsx"

type PhoneStatusPresentation = {
  readonly description: string
  readonly heading: string
  readonly icon: "notice" | "status"
}

const presentations = {
  REVERIFICATION_REQUIRED: { description: "등록된 번호를 다시 확인한 뒤 이용할 수 있습니다.", heading: "휴대전화 확인이 필요합니다", icon: "notice" },
  UNVERIFIED: { description: "휴대전화가 확인되면 상품권을 받을 번호가 안전하게 연결됩니다.", heading: "아직 확인된 휴대전화가 없습니다", icon: "status" },
  VERIFIED: { description: "확인된 번호는 일부만 표시하며 서버에서 확인된 상태만 안내합니다.", heading: "휴대전화가 확인되었습니다", icon: "status" },
} as const satisfies Readonly<Record<PhoneVerificationState, PhoneStatusPresentation>>

export const PhoneStatusPanel = ({ status }: { readonly status: PhoneVerificationStatus }) => {
  const presentation = presentations[status.verificationState]
  return (
    <output aria-live="polite" className={`state-panel phone-status-panel phone-status-${status.verificationState.toLowerCase().replaceAll("_", "-")}`} data-phone-verification-state={status.verificationState}>
      <span className="state-icon" data-state-icon={presentation.icon}>
        <Icon name={presentation.icon} />
      </span>
      <h2>{presentation.heading}</h2>
      <p className="phrase-safe-block">{presentation.description}</p>
      {status.maskedRecipient === null ? null : (
        <dl className="detail-grid phone-status-detail">
          <div>
            <dt>받는 번호</dt>
            <dd>{status.maskedRecipient}</dd>
          </div>
        </dl>
      )}
    </output>
  )
}
